var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"right","padding":"10px","background":"#fff"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.clickPrintBtn}},[_vm._v("打印")])],1),_c('div',{staticStyle:{"background-color":"white","padding":"15pt 15pt 50pt 15pt"}},[_c('div',{staticClass:"printArea"},[_c('tableHeader')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }